import useSWR from 'swr';
import type { AxiosError } from 'axios';
import axios from 'axios';
import type { ILabelValuePair } from '../../components/marking/MarkingInterfaces';

const GetWorkViewLayouts = () :
{
  layouts: ILabelValuePair[] | undefined,
  isLoading: boolean,
  isError: boolean, } => {
  const fetcher = (url: string) => axios.get<ILabelValuePair[]>(url)
    .then((response) => response.data);

  const { data, error } = useSWR<ILabelValuePair[], AxiosError>('/workView/GetWorkViewLayoutTypes',
    (url) => fetcher(url));

  return {
    layouts: data,
    isLoading: !error && !data,
    isError: Boolean(error),
  };
};

export default GetWorkViewLayouts;
